module.exports = __webpack_public_path__ + "img/logo.aa508b75.jpg";